import React, { useEffect } from 'react';
import { parse } from 'query-string';
import { HatTokenValidation } from '@dataswift/hat-js/lib/utils/HatTokenValidation';
import { useHistory, useLocation } from 'react-router-dom';
import { config } from '../../configs/config';
import { useAuth } from '../../hooks/useAuth';
import Loading from '../../components/Common/Loading';
import { ROUTES } from '../../constants/route';
import { getCustomerFirstLogin } from '../../services/c2dcrm';

type Query = {
  token?: string | null;
};

const defaultPage = ROUTES.MERCHANT_LOGIN;

const AuthCallbackPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { loginPDA } = useAuth();
  const { token } = parse(location.search) as Query;

  useEffect(() => {
    const validateUser = async () => {
      if (!token) {
        history.replace('/');
        return;
      }

      const decodedToken = HatTokenValidation.decodeToken(token);

      if (
        !HatTokenValidation.isEncodedTokenExpired(token) &&
        decodedToken.application === config.applicationId
      ) {
        window.localStorage.setItem(config.jwtTokenKey, token);
        loginPDA(token);

        try {
          const response = await getCustomerFirstLogin(token);
          const firstLogin: boolean = response.data?.value;

          history.replace(defaultPage);
        } catch (e) {
          history.replace(defaultPage);
        }
        return;
      }

      history.replace('/');
    };

    validateUser();
  }, []);

  return <Loading />;
};

export default AuthCallbackPage;
